/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reaction/attack_enemies': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M5.67 15L10 7.5l4.33 7.5z"/><path pid="1" d="M18.949 17.5H1.051L10 2l8.949 15.5zm-16.166-1h14.434L10 4 2.783 16.5z"/>'
  }
})
